import classes from "../Pages.module.css";
import { Row, Col, Tabs, Skeleton, message } from "antd";
import axios from "axios";
import DataContext from "../../../Context/dataContext";
import { useState, useEffect, useContext } from "react";
import BasicDetail from "./BasicDetail";
import SizeDetail from "./SizeDetail";
// import dayjs from "dayjs";
import SyncLoader from "react-spinners/SyncLoader";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const { TabPane } = Tabs;

const RequisitionView= (props) => {
  const { id } = useParams();
  const employeeData = useContext(DataContext);

  const history = useNavigate();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(true);
  const [editDode, setEditDode] = useState(true);
  const [allData, setAllData] = useState(null);
  const [editMode1, setEditMode1] = useState(true);
  const [storeData, setStoreData] = useState(null);
  const [ad, setAD] = useState(null);
  const [vd, setVD] = useState(null);
  const [itemm, setItemm] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [addres, setAddres] = useState(null);
  // const [outjobno, setoutJobNo] = useState(null);
  const [responseDataArray, setResponseDataArray] = useState([]);
  const [editDisable, setEditDisable] = useState(true);
  const [dataFetchingCompleted, setDataFetchingCompleted] = useState();

  useEffect(() => {
    setAllData(null);
    setStoreData(null);
    setAD(null);
   
    axios
      .get(employeeData.URL + "/api/v1/jobworkInward/" + id, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response,"response in edit mode");
        setItemm(response.data.data);
        setDataFetchingCompleted(response.data.data.prodDetail.length);
        const dlr_code = response.data.data.prodHdr[0].dealer_code;
         axios.get(
          employeeData.URL + `/api/v1/jobworkInward/fetchCustomers`,
          {
            withCredentials: true,
            params: { dealer_code: dlr_code  },
          }
        ).then((secondResponse)=>{
          setCustomers(secondResponse.data);
        });
        console.log("res------------------------------------");
        const cstcode = response.data.data.prodHdr[0].cust_code;
        const out_job_no = response.data.data.prodHdr[0].out_job_no;
        // setoutJobNo(out_job_no);
        axios.get(
          employeeData.URL + `/api/v1/jobworkInward/fetchAddress`,
          {
            withCredentials: true,
            params: { cust_code: cstcode  },
          }
        ).then((thirdResponse)=>{
          setAddres(thirdResponse.data);
        });

        
        console.log("res------------------------------------");
        setAllData((allData) => {
          let newDetails = response.data.data;

          newDetails.prodDetail.forEach((detail) => {
            detail.Mode = true;
          });

          return {
            ...newDetails,
          };
        });
        console.log("res------------------------------------");
        setStoreData((storeData) => {
          let newDetails = response.data.data;

          return {
            ...newDetails,
          };
        });
      })
      .catch((error) => {
        // // console.log(error);
      });
    
   axios
        .get(employeeData.URL + "/api/v1/jobworkInward/additional-data", {
          withCredentials: true,
        })
      .then((response) => {
        console.log(response,"additional data in req view is this ");
        setAD((ad) => {
          let newad = response.data.data;
          return {
            ...newad,
            
          };
        });
      })
      .catch((error) => {
        // // console.log(error);
      });
   
  }, []);
  useEffect(() => {
    setEditMode(true);
    setAD(null);
    setLoading(false);
    axios
      .get(employeeData.URL + "/api/v1/jobworkInward/additional-data-vendor", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        setVD((ad) => {
          let newad = response.data.dbData;
          return {
            ...newad,
          };
        });
      })
      .catch((error) => {
        // console.log(error);
      });
  }, []);

  useEffect(() => {
    const fetchData = async (item, index) => {
      try {
        // // console.log(item.item_code);
        const response = await axios.get(
          `${employeeData.URL}/api/v1/jobworkInward/additional-data-of-hsn/${item.item_code}`,
          {
            withCredentials: true,
          }
        );
        // // console.log(response.data.data);
        const data = response.data.data;
        console.log(data,"reqqqqqqqqqqqqqqqViewwwwwwwwwwwwwwwwwwwwwdata");
        setResponseDataArray((prevDataArray) => {
          const newArray = [...prevDataArray];
          newArray[index] = data; // Set the response data at the correct index
          return newArray;
        }); // // // console.log(data); // Do something with the data
      } catch (error) {
        console.error(
          `Error fetching data for item_code ${item.item_code}:`,
          error
        );
      }
    };
    
    const fetchAllData = async () => {
      if (!itemm || !itemm.prodDetail) {
        console.error("itemm or itemm.prodDetail is null or undefined", itemm);
        return;
      }

      try {
        await Promise.all(
          itemm.prodDetail.map((item, index) => fetchData(item, index))
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
   
    fetchAllData().then(() => {
       console.log(responseDataArray.length);
      // // console.log(responseDataArray.length);
    });
  }, [itemm, setResponseDataArray]);

  

  // const isValidObject = (obj) => {
  //   return obj.size && obj.grade && obj.uom && obj.cost;
  // };

  // Determine if all objects in responseDataArray meet the condition
  // const allObjectsValid = responseDataArray.every(isValidObject);

  const handleEditButtonClick = () => {
    setEditMode(true);
    setEditDode(true);
  };

  const handleSave = (event) => {
    const postData = {
      ...allData,
    };

    // const postDataS = {
    //   ...storeData,
    //   prodDetail: allData.prodDetail.map((dep) => {
    //     return {
    //       ...dep,
    //     };
    //   }),
    // };

     console.log(postData);

   
    console.log(postData,"---postdata is ths-----");
    // // console.log(postData);

    postData.prodDetail.forEach((lang, index) => {
      if (!lang.inward_uniq) {
        postData.prodDetail[index] = {
          ...lang,
          PARAM: "INSERT",
        };
      } else {
        postData.prodDetail[index] = {
          ...lang,
          PARAM: "UPDATE",
        };
      }
    });

    storeData.prodDetail.forEach((lang, index) => {
      const dataIndex = postData.prodDetail.findIndex(
        (element) => element.inward_uniq === lang.inward_uniq
      );
      if (dataIndex === -1) {
        postData.prodDetail.push({
          inward_uniq: lang.inward_uniq,
          PARAM: "DELETE",
        });
      }
    });

    // // console.log(JSON.stringify(postData, undefined, 2));
    if (
      !postData.prodHdr[0].packing_type ||
      !postData.prodHdr[0].chalan_no ||
      !postData.prodHdr[0].ppc_date ||
      !postData.prodHdr[0].mode_of_trans ||
      !postData.prodHdr[0].trans_account ||
      !postData.prodHdr[0].gross_wt ||
      !postData.prodHdr[0].tare_wt ||
      !postData.prodHdr[0].net_wt ||
      !postData.prodHdr[0].grno ||
      !postData.prodHdr[0].gr_date ||
      !postData.prodHdr[0].type_stock ||
      !postData.prodHdr[0].dealer_code ||
      !postData.prodHdr[0].cust_code ||
      !postData.prodHdr[0].place_of_supply ||
      !postData.prodHdr[0].remark
    ) {
      message.error({
        content: "Please Fill The Mandatory Fields!!!",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      setLoading(false);
      return; // Stop further execution if validation fails
    }

    const allFieldsNull = postData.prodDetail.every(
      (detail) =>
        // detail.ppc_code === null &&
        detail.item_code === null &&
        detail.hsn === null &&
        detail.grade === null &&
        detail.uom_code === null &&
        detail.size_code === null 
    //     detail.len === null &&
    //     detail.pcs === null &&
    //     detail.total === null &&
    //     detail.rate === null &&
    //     detail.burning === null &&
    //     detail.remark === null &&
    //     detail.wt === null &&
    //     detail.total_2 === null 
    );

    if (allFieldsNull) {
      message.error({
        content: "Please Fill At Least One Row In The Item Detail Tab!!!",
        className: "custom-class",
        style: {
          marginTop: "1vh",
        },
      });
      setLoading(false);
      return; // Stop further execution if all fields are null
    }

    const fieldDisplayNameMap = {
      ppc_code: "Ppc_code",
      item_code: "Item",
      hsn:"hsn",
      grade: "Grade",
      size_code: "Size",
      len: "lenght",
      pcs: "Quantity",
      total: "total",
      rate: "Rate",
      burning: "burning",
      uom_code:"uom_code",
      wt:"wt",
      total_2: "Total_Amount",
    };

    const invalidRows = postData.prodDetail.filter((detail, index) => {
      if (detail.PARAM === "DELETE") {
        return false;
      }
      const mandatoryFields = [
       
        "item_code",
        "grade",
        "size_code",
        
        
      ];
      const missingFields = mandatoryFields.filter(
        (field) =>
          detail[field] === null ||
          detail[field] === undefined ||
          detail[field] === ""
      );
      if (missingFields.length > 0) {
        // Map field names to display names
        const displayNames = missingFields.map(
          (field) => fieldDisplayNameMap[field]
        );
        // Construct error message for this row
        const errorMessage = `Row ${
          index + 1
        }: Please Fill All Mandatory Fields (${displayNames.join(", ")})`;
        // Display error message
        message.error({
          content: errorMessage,
          className: "custom-class",
          style: {
            marginTop: "1vh",
          },
        });
        //  // // console.log(sizeRef.current.state);

        setLoading(false);
        return true;
      }
      return false;
    });
    if (invalidRows.length > 0) {
      return; // Stop further execution if validation fails
    }

    axios
      .patch(employeeData.URL + "/api/v1/jobworkInward/" + id, postData, {
        withCredentials: true,
        credentials: "include",
      })
      .then((response) => {
        message.success({
          content: "Job work Updated Successfully!!!",
          className: "custom-class",
          style: {
            marginTop: "2vh",
          },
        });
        setLoading(false);
        history("/jobwork/transection/job-work-inward");
    
      })
      .catch((err) => {
        message.error({
          content: "An Error Occurred!!!!",
          className: "custom-class",
          style: {
            marginTop: "2vh",
          },
        });
        setLoading(false);
      });

    // setEditMode(false);
  };

  const handleCancel = (event) => {
    setLoading(false);
    history("/jobwork/transection/job-work-inward");
  };
 console.log(allData,"all data is this ",ad ," ad is this ",responseDataArray,"response Data Array");
  return (
    <>
      {allData && ad && responseDataArray.length === dataFetchingCompleted ? (
        <Row className={classes["RowP"]}>
          <Col
            lg={editMode ? 13 : 19}
            md={editMode ? 13 : 19}
            className={classes["Col"]}
          ></Col>
          {editMode ? (
            <>
              <Col md={4}>
                {loading ? (
                  <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                ) : (
                  <button
                    style={{
                      padding: "7px 30px 14px 24px",
                      borderRadius: "50px",
                      background: "transparent",
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "1.5",
                      color: "#071e54",
                      WebkitAppearance: "none",

                      boxShadow:
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                      height: "40px",

                      // Ensure the button takes full width
                    }}
                    onClick={(event) => handleSave(event)}
                    className={classes["ProfileButtonn"]}
                    id="save"
                    onMouseOver={(event) => {
                      event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                    }}
                    onMouseOut={(event) => {
                      event.target.style.boxShadow =
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                    }}
                  >
                    Save
                  </button>
                )}
              </Col>
              <Col md={4}>
                {loading ? (
                  <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                ) : (
                  <button
                    style={{
                      padding: "7px 30px 14px 24px",
                      borderRadius: "50px",
                      background: "transparent",
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "1.5",
                      color: "#071e54",
                      WebkitAppearance: "none",

                      boxShadow:
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                      height: "40px",

                      // Ensure the button takes full width
                    }}
                    onClick={(event) => handleCancel(event)}
                    onMouseOver={(event) => {
                      event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                    }}
                    onMouseOut={(event) => {
                      event.target.style.boxShadow =
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                    }}
                    className={classes["ProfileButtonn"]}
                  >
                    Cancel
                  </button>
                )}
              </Col>
            </>
          ) : (
            <Col md={4}>
              <button
                onClick={handleEditButtonClick}
                className={classes["ProfileButton"]}
              >
                Edit Details
              </button>
            </Col>
          )}
          <Col lg={1} md={1}></Col>
          <Col lg={24} md={24} className={classes["Col"]}>
            <div className={classes["EditView"]}>
              <span style={{ fontWeight: "bold", color: "#1677ff" }}>
              Jobwork Inward Details
              </span>
              <BasicDetail
                create={true}
                ad={ad}
                vd={vd}
                setData={setAllData}
                data={allData.prodHdr[0]}
                editMode={editMode}
                customers={customers}
                editMode1={editMode1}
                addres={addres}
                editDisable={editDisable}
              />
              <Tabs
                defaultActiveKey="0"
                centered // Center the Tabs
                type="card" // Set the type to "card"
                tabBarGutter="10"
                id="tabs"
                tabBarUnderlineStyle={{ borderWidth: 0 }} // Remove border from the tab bar
              >
                <TabPane
                  tab={<span>Invoice Details</span>}
                  key="0"
                  style={{ border: "none !important" }}
                >
                  <div
                    style={{
                      overflowX: "scroll",
                      padding: "10px",
                      // border: "2px solid red",
                    }}
                  >
                    {console.log(responseDataArray,"response data array is this")}
                    {dataFetchingCompleted && (
                      <SizeDetail
                        ad={ad}
                        // id={id} // Add this
                        setData={setAllData}
                        data={allData.prodDetail}
                        editMode={editMode}
                        editDode={editDode}
                        setEditDode={setEditDode}
                        responseDataArray={responseDataArray}
                        editDisable={editDisable}
                        lenght={dataFetchingCompleted}
                        
                      />
                    )}
                  </div>
                </TabPane>
              </Tabs>
            </div>
          </Col>
        </Row>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
}

export default RequisitionView;
